export default __webpack_public_path__ + "img/service_request.png";